import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CursorGlow() {
    const [enabled, setEnabled] = useState(false);
    const x = useMotionValue(-400);
    const y = useMotionValue(-400);
    const sx = useSpring(x, { stiffness: 100, damping: 20, mass: 0.4 });
    const sy = useSpring(y, { stiffness: 100, damping: 20, mass: 0.4 });

    useEffect(() => {
        if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
        setEnabled(true);
        const move = (e) => {
            x.set(e.clientX - 160);
            y.set(e.clientY - 160);
        };
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, [x, y]);

    if (!enabled) return null;
    return (
        <motion.div
            aria-hidden="true"
            className="pointer-events-none fixed left-0 top-0 z-30 h-80 w-80 rounded-full"
            style={{
                x: sx,
                y: sy,
                background:
                    "radial-gradient(circle, rgba(0,240,255,0.10) 0%, rgba(93,63,211,0.07) 40%, transparent 70%)",
            }}
        />
    );
}
